import * as ActionTypes from './actionTypes'

export const fetchSuccess = (closures) => ({
  type: ActionTypes.FETCH_SUCCESS,
  closures,
})

export const fetchStart = () => ({
  type: ActionTypes.FETCH_START,
})

export const fetchFail = (error) => ({
  type: ActionTypes.FETCH_FAILURE,
  error,
})

export const fetchAgenciesSuccess = (agencies) => ({
  type: ActionTypes.FETCH_AGENCIES_SUCCESS,
  agencies,
})

export const fetchAgenciesStart = () => ({
  type: ActionTypes.FETCH_AGENCIES_START,
})

export const fetchAgenciesFail = (error) => ({
  type: ActionTypes.FETCH_AGENCIES_FAILURE,
  error,
})

export const selectClosures = (closureIds) => ({
  type: ActionTypes.SELECT_CLOSURES,
  closureIds,
})

export const clearSelection = () => ({
  type: ActionTypes.CLEAR_SELECTION,
})

export const nextClosure = () => ({
  type: ActionTypes.NEXT_CLOSURE,
})

export const prevClosure = () => ({
  type: ActionTypes.PREV_CLOSURE,
})

export const openEditor = (closure) => ({
  type: ActionTypes.OPEN_EDITOR,
  closure,
})

export const closeEditor = () => ({
  type: ActionTypes.CLOSE_EDITOR,
})

export const setAgencyId = (agencyId) => ({
  type: ActionTypes.SET_AGENCY_ID,
  agencyId,
})

export const setNotes = (notes) => ({
  type: ActionTypes.SET_NOTES,
  notes,
})

export const setPending = (pending) => ({
  type: ActionTypes.SET_PENDING,
  pending,
})

export const setReason = (reason) => ({
  type: ActionTypes.SET_REASON,
  reason,
})

export const setError = (error) => ({
  type: ActionTypes.SET_ERROR,
  error,
})

export const addClosure = (closure) => ({
  type: ActionTypes.ADD_CLOSURE,
  closure,
})

export const editClosure = (closure) => ({
  type: ActionTypes.EDIT_CLOSURE,
  closure,
})

export const removeClosure = (closureId) => ({
  type: ActionTypes.REMOVE_CLOSURE,
  closureId,
})

export const addSegments = (segments) => ({
  type: ActionTypes.ADD_SEGMENTS,
  segments,
})

export const removeSegments = (segments) => ({
  type: ActionTypes.REMOVE_SEGMENTS,
  segments,
})

export const hoverSegmentStart = (closureId, segmentId) => ({
  type: ActionTypes.HOVER_SEGMENT_START,
  closureId,
  segmentId,
})

export const hoverSegmentEnd = (closureId, segmentId) => ({
  type: ActionTypes.HOVER_SEGMENT_END,
  closureId,
  segmentId,
})
